// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".list-table{box-sizing:border-box}.baikeCat .el-select{width:48%;float:left}.v-modal{z-index:2000!important}.el-table .cell a.scan{padding:0 15px;border:1px solid #dcdfe6;border-radius:3px;margin-right:10px;line-height:26px;display:inline-block}.el-table .cell a.scan:hover{color:#409eff;border-color:#c6e2ff;background-color:#ecf5ff}.ellips2{display:-webkit-box;-webkit-box-orient:vertical;-webkit-line-clamp:2;overflow:hidden;max-height:45px}", ""]);
// Exports
module.exports = exports;
